module.exports = __webpack_public_path__ + "static/media/hotel.f28d3128.svg";